import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WorldMapService {

  constructor(private http: HttpClient) { }

  ReadWorldMap(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/globalmap/read`, params);
  }

  AddWorldMap(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/globalmap/add`, params);
  }

  UpdateWorldMap(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/globalmap/update`, params);
  }

  DeleteWorldMap(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/globalmap/delete`, params);
  }

  GetGeoLocationByAddress(address): Observable<any> {
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(`https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=AIzaSyCA-2k04S-e7tGMP9l40wlMOr7t1TY5qWE`);
  }
}
